import React, { useEffect, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import {
  BlockTitle,
  Col,
  Row,
  RSelect
} from "../../components/Component";

import { ErrorMessage } from "@hookform/error-message";
import {
  Controller,
  useFormContext
} from "react-hook-form";
import { NumericFormat, numericFormatter } from "react-number-format";
import { GET } from "../../helper/api";
import {
  BILL_STATUS,
  BILL_TYPE,
  INGREDIENT_OTHER_NOT_NEED_REQUEST,
} from "../../utils/Utils";

const BILL_TYPE_OPTIONS = Object.keys(BILL_TYPE).map((c) => ({
  label: BILL_TYPE[c],
  value: c,
}));


const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const BillOtherCreateForm = ({
  id,
  duplicateId,
  billData,
  disabledForm = false,
}) => {
  const { errors, register, control, setValue, watch } = useFormContext();
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [mortgageContractOptions, setMortgageContractOptions] = useState([]);


  const type = watch("type");
  useEffect(() => {

    GET(
      "/transaction-history/mortgage-contract",
      { status: "INIT" },
      true
    ).then(({ data }) => {
      setMortgageContractOptions((oldData) => {
        const newData = [...oldData];
        const values = oldData.map((e) => e.value);
        data?.forEach((c) => {
          if (!values.includes(c.contractId)) {
            newData.push({
              label: `${c.contractId} - ${c.bankName} - ${numericFormatter(
                `${c.amountUSD || c.amount || 0}`,
                {
                  thousandsGroupStyle: "thousand",
                  thousandSeparator: ",",
                  decimalScale: 2,
                  suffix: c.currency === "VND" ? "đ" : "",
                  prefix: c.currency === "USD" ? "$" : "",
                }
              )}`,
              value: c.contractId,
              data: c,
            });
          }
        });
        return newData;
      });
    });

    GET("customer", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setCustomerOptions(
          data.map(c => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        )
      } else {
        setCustomerOptions([]);
      }
    });
  }, []);

  useEffect(() => {
    GET("ingredient", {}, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setIngredientOptions(
          data.rows.filter(c => !!INGREDIENT_OTHER_NOT_NEED_REQUEST[c.id]).map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });


  }, []);


  return (
    <form className="position-relative">
      {disabledForm ? <div className="form-overlay"></div> : <></>}

      <div className="mb-4">
        <Row className="g-2">
          <Col size={12}>
            <BlockTitle tag="h5">Thông tin khách hàng</BlockTitle>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Loại đơn<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="type"
                  rules={{ required: "Vui lòng nhập thông tin" }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={BILL_TYPE_OPTIONS}
                      value={
                        BILL_TYPE_OPTIONS.find((c) => c.value === value) || null
                      }
                      onChange={(val) => {
                        onChange(val.value);
                        if (val.value !== value) {
                          setValue("customerId", "");
                        }
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="type"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Khách hàng <span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="customerId"
                  rules={{
                    required: "Vui lòng nhập thông tin",
                  }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={customerOptions.filter(c => c.data.type === type)}
                      value={
                        customerOptions.find((c) => c.value === value) || null
                      }
                      onChange={(val) => {
                        onChange(val.value);
                        setValue('billExternalContractId', null)
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="customerId"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Row className="mt-3 g-2">
        <Col size={12}>
          <BlockTitle tag="h5">Thông tin đơn hàng</BlockTitle>
        </Col>
        <Col md="6">
          <div className="form-group">
            <label className="form-label" htmlFor="customer">
              Mã đơn hàng <span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control"
                name="id"
                ref={register({
                  required: "Vui lòng nhập thông tin",
                })}
                disabled={!!id && !duplicateId}
              />
              <ErrorMessage
                errors={errors}
                name="id"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>


        <Col md="6">
          <div className="form-group">
            <label className="form-label" >
              Khoản vay
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="contractId"
                render={({ onChange, name, value, ref }) => (
                  <RSelect
                    isClearable
                    ref={ref}
                    name={name}
                    options={mortgageContractOptions}
                    value={
                      mortgageContractOptions.find((c) => c.value === value) ||
                      null
                    }
                    onChange={(val) => {
                      onChange(val?.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="contractId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col md="6">
          <div className="form-group">
            <label className="form-label" >
              Nguyên liệu<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="ingredientId"
                rules={{ required: "Vui lòng nhập thông tin" }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    ref={ref}
                    name={name}
                    options={ingredientOptions}
                    value={
                      ingredientOptions.find((c) => c.value === value) || null
                    }
                    onChange={(val) => onChange(val.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="ingredientId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>


        <Col md={6}>
          <div className="form-group">
            <label className="form-label" >
              Giá VNĐ<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="unitPrice"
                rules={{ required: "Vui lòng nhập thông tin" }}
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    className="form-control"
                    getInputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={2}
                    onValueChange={(val) => onChange(val.floatValue)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="unitPrice"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>


        <Col md="6">
          <div className="form-group">
            <label className="form-label" >
              Thời gian tạo đơn<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <input
                rows={3}
                className="form-control"
                type="datetime-local"
                name="createdAt"
                ref={register({ required: "Vui lòng nhập thông tin" })}
              />
              <ErrorMessage
                errors={errors}
                name="createdAt"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="12">
          <div className="form-group">
            <label className="form-label" >
              Ghi chú
            </label>
            <div className="form-control-wrap">
              <textarea
                rows={3}
                className="form-control"
                style={{ height: "unset" }}
                name="note"
                ref={register()}
              />
            </div>
          </div>
        </Col>
      </Row>
      <div className="mt-4">
        <Row className="mt-4">
          <Col size="12" md={3}>
            <div className="form-group">
              <label className="form-label" >
                Trạng thái đơn<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="status"
                  rules={{
                    required: "Vui lòng nhập thông tin",
                  }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={BILL_STATUS_OPTIONS}
                      value={
                        BILL_STATUS_OPTIONS.find((c) => c.value === value) ||
                        null
                      }
                      onChange={(val) => onChange(val.value)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="status"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </form>
  );
};

export default BillOtherCreateForm;
